import { render, staticRenderFns } from "./member-chat.vue?vue&type=template&id=66bc8a46&scoped=true&"
import script from "./member-chat.vue?vue&type=script&lang=js&"
export * from "./member-chat.vue?vue&type=script&lang=js&"
import style0 from "./member-chat.vue?vue&type=style&index=0&id=66bc8a46&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66bc8a46",
  null
  
)

export default component.exports